import { getRaces, deleteRace } from "src/store/Slices/UsersRatingSlice"
import { useDispatch, useSelector } from "react-redux"
import { useState, useEffect } from "react"
import { Dropdown } from "antd"
import AntdTable from "src/components/AntdTable/Table"
import AntdMobileTable from "src/components/AntdMobileTable/AntdMobileTable"
import RacesParticipants from "./RacesParticipants"
import dayjs from "dayjs"
import TableTitle from "src/pages/Administrator/Helpers/TableTitle"
import SetRaceResult from "./Modals/SetRaceResult"
import { DownOutlined } from "@ant-design/icons"
import AddEditRaceModal from "./Modals/AddEditRaceModal.jsx"
import DeleteRaceModal from "./Modals/DeleteRaceModal"

const Races = () => {
  const dispatch = useDispatch()

  const [page, setPage] = useState(1)
  const [pageSize, setPageSize] = useState(20)
  const [showRacesParticipantsTable, setShowRacesParticipantsTable] =
    useState(false)
  const [raceId, setRaceId] = useState(null)
  const [resultModalOpen, setResultModalOpen] = useState(false)
  const [selectedRaceForResult, setSelectedRaceForResult] = useState(null)
  const [selectedRace, setSelectedRace] = useState(null)
  const [isAddEditModalOpen, setIsAddEditModalOpen] = useState({
    open: false,
    flag: "edit" | "add",
    raceInfo: null,
  })

  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState({
    open: false,
    raceId: null,
  })

  const racesInfo = useSelector((state) => state.UsersRatingSlice?.racesInfo)
  const loading = useSelector((state) => state.UsersRatingSlice?.isLoading)

  useEffect(() => {
    dispatch(getRaces())
  }, [])

  const rows =
    racesInfo?.data?.value?.rows?.map((element) => {
      return {
        key: element?.key || element?.id,
        id: element?.id,
        clubId: element?.clubId,
        club: element?.club,
        isCompleted: element?.isCompleted,
        date: dayjs(element?.date).format("YYYY.MM.DD HH:MM"),
        registeredCount: element?.registeredCount,
        participantsCount: element?.participantsCount || "Нет ограничений",
      }
    }) || []

  const getDropdownItems = (record) => {
    const items = []

    const isCompleted = record?.isCompleted === "Завершена"

    if (!isCompleted) {
      items.push({
        key: "setResult",
        label: "Установить результат",
        onClick: () => handleOpenSetResult(record),
      })
    }
    items.push({
      key: "editRace",
      label: "Редактировать гонку",
      onClick: () => handleEditRace(record),
    })
    items.push({
      key: "deleteRace",
      label: "Удалить гонку",
      onClick: () => {
        setSelectedRace(record)
        handleDeleteRace(record)
      },
    })

    return items
  }

  const handleDeleteRace = (race) => {
    setIsDeleteModalOpen({
      open: true,
      raceId: race?.id || null,
    })
  }

  const onDeleteRaceClickYes = () => {
    setIsDeleteModalOpen({
      open: false,
      raceId: null
    })
    if (selectedRace?.id) {
      dispatch(deleteRace(selectedRace?.id || null)).then(() => {
 dispatch(getRaces())
      }) 
    }
  }

  const handleEditRace = (race) => {
    setIsAddEditModalOpen({
      open: true,
      flag: "edit",
      raceInfo: race,
    })
  }

  const baseColumns = racesInfo?.data?.value?.columns || []

  const columns = [
    ...baseColumns.map((element) => ({
      ...element,
    })),
    {
      title: "Действия",
      key: "actions",
      width: 100,
      align: "center",
      render: (_, record) => {
        const items = getDropdownItems(record)

        if (items.length === 0) {
          return <span style={{ color: "#999" }}>Нет действий</span>
        }

        return (
          <Dropdown
            menu={{
              items: items,
            }}
            trigger={["click"]}
            placement='bottomRight'
          >
            <a
              className='text-primary text-decoration-none'
              onClick={(e) => e.stopPropagation()}
              style={{ cursor: "pointer" }}
            >
              Действия <DownOutlined />
            </a>
          </Dropdown>
        )
      },
    },
  ]

  const onClickRowOneAction = (record) => {
    console.log("record", record)
    setRaceId(record?.id)
    console.log(raceId)
    setShowRacesParticipantsTable(true)
  }

  const handleCloseRacesParticipants = () => {
    setShowRacesParticipantsTable(false)
    setRaceId(null)
  }

  useEffect(() => {
    console.log("racesInfo", racesInfo)
    console.log("columns", columns)
    console.log("rows", rows)
    console.log("totalCount", racesInfo?.data?.value?.totalCount)
  }, [columns, rows])

  const handleAddRace = () => {
    setIsAddEditModalOpen({
      open: true,
      flag: "add"
    })
  }

  const handleOpenSetResult = (record) => {
    setSelectedRaceForResult(record)
    setResultModalOpen(true)
  }

  const handleCloseSetRaceResults = () => {
    setResultModalOpen(false)
    setSelectedRaceForResult(null)
  }

 

  return (
    <>
      {window.innerWidth >= 768 ? (
        <AntdTable
          page={page}
          setPage={setPage}
          pageSize={pageSize}
          setPageSize={pageSize}
          loading={loading}
          columns={columns}
          rows={rows}
          total={racesInfo?.data?.value?.totalCount || 0}
          onClickRowOne={(record) => onClickRowOneAction(record)}
          title={() => (
            <TableTitle
              onClickOpenModal={handleAddRace}
              mnemoButton={false}
            />
          )}
          
        />
      ) : (
        <AntdMobileTable
          page={page}
          setPage={setPage}
          pageSize={pageSize}
          setPageSize={pageSize}
          loading={loading}
          columns={columns}
          rows={rows}
          total={racesInfo?.data?.value?.totalCount || 0}
         
        />
      )}

      {showRacesParticipantsTable && raceId !== null && (
        <RacesParticipants
          raceId={raceId}
          visible={showRacesParticipantsTable}
          onClose={handleCloseRacesParticipants}
        />
      )}

      <SetRaceResult
        visible={resultModalOpen}
        setVisible={setResultModalOpen}
        onClose={handleCloseSetRaceResults}
        raceData={selectedRaceForResult}
        raceId={raceId}
      />

      <AddEditRaceModal
        visible={isAddEditModalOpen}
        setVisible={setIsAddEditModalOpen}
        setPage={setPage}
        setPageSize={setPageSize}
      />

      <DeleteRaceModal
        visible={isDeleteModalOpen}
        setVisible={setIsDeleteModalOpen}
        setPage={setPage}
        setPageSize={setPageSize}
        onClickYes={onDeleteRaceClickYes}
      />
    </>
  )
}

export default Races
